import { render, staticRenderFns } from "./FilePreview.vue?vue&type=template&id=c8b04846&scoped=true"
import script from "./FilePreview.vue?vue&type=script&lang=js"
export * from "./FilePreview.vue?vue&type=script&lang=js"
import style0 from "./FilePreview.vue?vue&type=style&index=0&id=c8b04846&prod&scoped=true&lang=scss"
import style1 from "./FilePreview.vue?vue&type=style&index=1&id=c8b04846&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b04846",
  null
  
)

export default component.exports